import { ForemanPromocode, GeneratePromocodeParams } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { GENERATED_PROMOCODE } from '../my-account-state';

export const GENERATE_PROMOCODE = '[MyAccount] Generate Promocode';
export const GENERATE_PROMOCODE_SUCCESS = '[MyAccount] Generate Promocode Success';
export const GENERATE_PROMOCODE_FAIL = '[MyAccount] Generate Promocode Fail';
export const GENERATE_PROMOCODE_RESET = '[MyAccount] Generate Promocode Reset';

export class GeneratePromocode extends StateUtils.LoaderLoadAction {
  readonly type = GENERATE_PROMOCODE;

  constructor(public payload: GeneratePromocodeParams) {
    super(GENERATED_PROMOCODE);
  }
}

export class GeneratePromocodeSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = GENERATE_PROMOCODE_SUCCESS;

  constructor(public payload: ForemanPromocode) {
    super(GENERATED_PROMOCODE);
  }
}

export class GeneratePromocodeFail extends StateUtils.LoaderFailAction {
  readonly type = GENERATE_PROMOCODE_FAIL;

  constructor() {
    super(GENERATED_PROMOCODE);
  }
}

export class GeneratePromocodeReset extends StateUtils.LoaderResetAction {
  readonly type = GENERATE_PROMOCODE_RESET;

  constructor() {
    super(GENERATED_PROMOCODE);
  }
}

export type GeneratePromocodeActions =
  | GeneratePromocode
  | GeneratePromocodeSuccess
  | GeneratePromocodeFail
  | GeneratePromocodeReset;
